import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmbedVideoYoutubeComponent } from './embed-video/embed-video-youtube/embed-video-youtube.component';
import { EmbedVideoOverlayComponent } from './embed-video-overlay/embed-video-overlay.component';
import { EmbedVideoComponent } from './embed-video/embed-video.component';

@NgModule({
    declarations: [
        EmbedVideoYoutubeComponent,
        EmbedVideoOverlayComponent,
        EmbedVideoComponent
    ],
  exports: [
    EmbedVideoComponent,
    EmbedVideoYoutubeComponent
  ],
    imports: [
        CommonModule
    ]
})
export class EmbedVideoModule { }
